import { startCase, camelCase } from 'lodash';

const customReplacements = {
  '3 Pl': '3PL',
  And: 'and',
  For: 'for',
};

export const formatScreamingSnakesToPrettyStrings = (screamingSnake: string): string | null => {
  if (!screamingSnake?.length) return null;
  let formatted = startCase(camelCase(screamingSnake.split('_').join(' ')));
  if (!formatted) return null;
  for (const [before, after] of Object.entries(customReplacements)) {
    formatted = formatted.replace(before, after);
  }
  return formatted;
};
